// @ vendors
const apiURLBuilder = require('../core/apiURLBuilder');
import { history } from 'routes/history';
const Api = require('../services/api');
const actionTypes = require('constants/actionTypes');
// @ helpers
import { getLanguage } from 'core/i18n';
// @ constants
const { BASE_PATH } = require('constants/index');

let value;
const languaje = getLanguage();

const getCMS = (text, tooltip) => dispatch => {
    value = `${text},${tooltip}`;
    const saveRequestData = {
        header: {},
        query: {
            language: languaje,
            channel: 'onboarding',
            webContentId: value,
        },
    };

    return Api.get(apiURLBuilder.getURL('getCMSContent'), saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            let data = {};

            if (response.body.data.nodes.length) {
                response.body.data.nodes.map(value => {
                    if (value.field_location_id[0].value.includes('tooltip')) {
                        data.tooltip = value.body[0].value;
                    } else {
                        data.text = value.body[0].value;
                    }
                });

                if (text.includes('registro')) {
                    dispatch({
                        type: actionTypes.LOAD_CMS_REGISTER,
                        data: data,
                    });
                } else if (text.includes('additional')) {
                    dispatch({
                        type: actionTypes.LOAD_CMS_ADDITIONAL,
                        data: data,
                    });
                } else {
                    dispatch({
                        type: actionTypes.LOAD_CMS_POSTFIOC_APPROVED,
                        data: data,
                    });
                }
            }
        } else {
            history.push(BASE_PATH + '/errors');
        }
    });
};

const getCMSNotApproved = (text, tooltip, title) => dispatch => {
    value = `${text},${tooltip},${title}`;
    const saveRequestData = {
        header: {},
        query: {
            language: languaje,
            channel: 'onboarding',
            webContentId: value,
        },
    };

    return Api.get(apiURLBuilder.getURL('getCMSContent'), saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            let data = {};

            if (response.body.data.nodes.length) {
                response.body.data.nodes.map(value => {
                    if (value.field_location_id[0].value.includes('tooltip')) {
                        data.tooltip = value.body[0].value;
                    } else if (value.field_location_id[0].value.includes('text')) {
                        data.text = value.body[0].value;
                    } else {
                        data.title = value.body[0].value;
                    }
                });

                dispatch({
                    type: actionTypes.LOAD_CMS_POSTFIOC_NOT_APPROVED,
                    data: data,
                });
            }
        } else {
            history.push(BASE_PATH + '/errors');
        }
    });
};

const getCMSStandby = listItem => dispatch => {
    const saveRequestData = {
        header: {},
        query: {
            language: languaje,
            channel: 'onboarding',
            webContentId: listItem,
        },
    };

    return Api.get(apiURLBuilder.getURL('getCMSContent'), saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            let data = {};

            if (response.body.data.nodes.length) {
                data.text = response.body.data.nodes[0].body[0].value;
            }

            dispatch({
                type: actionTypes.LOAD_CMS_STAND_BY,
                data: data,
            });
        } else {
            history.push(BASE_PATH + '/errors');
        }
    });
};

export default {
    getCMS,
    getCMSNotApproved,
    getCMSStandby,
};
